<template>
  <div class="tabs-container">
    <div class="tab-item" :class="{'active': item.value === modelValue}" v-for="(item, index) in options" :key="index" @click="handleClick(item.value)">
      {{item.label}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default () {
        return []
      }
    },
    modelValue: {
      type: [String, Number],
      default: ''
    }
  },
  methods: {
    handleClick (value) {
      this.$emit('update:modelValue', value)
      this.$emit('tab-click', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs-container {
  display: inline-block;
  .tab-item {
    display: inline-block;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    color: #666;
    border-radius: 24px;
    min-width: 108px;
    padding: 5px 0;
    text-align: center;
    cursor: pointer;
    &.active {
      background-color: #FD3374;
      color: #fff;
    }
  }
}
</style>